package one.healthium.profile.navigation.meal_plan_settings

import com.arkivanov.decompose.ComponentContext

class DefaultMealPlanSettingsComponent(
    componentContext: ComponentContext,
    private val onBackClicked: () -> Unit,
) : MealPlanSettingsComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}
